// Mapping between config property names and query parameter names
export const CONFIG_TO_QUERY_MAP = {
  themeMode: 'theme',
  accentColor: 'accent',
  borderRadius: 'radius',
  fontFamily: 'font',
  appName: 'name',
  appLogoUrl: 'logo',
  authMethods: 'auth',
  showCoinbaseFooter: 'cbFooter',
  accountCreationType: 'account',
} as const;

// Reverse mapping: query parameter names to config property names
export const QUERY_TO_CONFIG_MAP = Object.entries(CONFIG_TO_QUERY_MAP).reduce(
  (acc, [configKey, queryKey]) => {
    acc[queryKey] = configKey;
    return acc;
  },
  {} as Record<string, string>,
);
